import { useEffect, useMemo, useState } from "react";
//@ts-ignore
import style from "../style/Login.module.css";
import cryptoJs from "crypto-js";

//@ts-ignore
import { LoadingSpinner, SelectInput } from "@viuti/recursos";
import { LogoAppVertical } from "../../../models/Icons";
import { sortLocalsCentralFirst } from "../../../../../utils/sortLocalsCentralFirst";

const LoungesSelectView = ({
  loungesList: rawLoungesList,
  loginForm,
  setLoginForm,
  businessList,
}) => {
  const loungesList = useMemo(() => sortLocalsCentralFirst(rawLoungesList), [rawLoungesList]);
  const [lounges, setLounges] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [actualLounge, setActualLounge] = useState<any>([]);
  function encrypt(key, data) {
    let dataEncrypt = cryptoJs.AES.encrypt(data, "").toString();
    localStorage.setItem(key, dataEncrypt);
  }
  encrypt("IsLogged", "logged in session");

  useEffect(() => {
    if (loginForm.businessId === null) {
      setLoginForm({
        ...loginForm,
        businessId: businessList[0].businessId,
      });
      setActualLounge(businessList);
    } else {
      setActualLounge(
        businessList.filter((e) => e.businessId === loginForm.businessId)
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (actualLounge?.length >= 1) {
      setIsLoading(false);
    }
  }, [actualLounge]);

  useEffect(() => {
    if (isLoading) return;
    // Save accessible locals for multi-sede switcher
    if (loungesList?.length > 1) {
      const accessibleLocals = loungesList.map((l) => ({
        id: l.loungeId,
        name: l.loungeName,
        isCentral: !!l.isCentral,
      }));
      localStorage.setItem("accessible_locals", JSON.stringify(accessibleLocals));
    }
    if (loungesList?.length === 1) {
      localStorage.setItem(
        "selectedLocal",
        JSON.stringify({
          id: loungesList[0].loungeId,
          nombre: loungesList[0].loungeName,
        })
      );
      setLoginForm({
        ...loginForm,
        loungeId: loungesList[0].loungeId,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  if (isLoading) return <LoadingSpinner isVisible={true} size={64} />;

  return (
    <article className={style.articleSelect}>
      <img className={style.logo} src={LogoAppVertical} alt="Prikly" />
      <h1 style={{ textAlign: "center", whiteSpace: "nowrap" }}>Elige el local de tu preferencia.</h1>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 160px)", gap: 16, justifyContent: "center", marginTop: 24, maxHeight: "50vh", overflowY: "auto", padding: "4px 8px" }}>
        {loungesList.map((l) => (
          <button
            key={l.loungeId}
            onClick={() => {
              setLounges(l.loungeName.toUpperCase());
              setLoginForm({ ...loginForm, loungeId: l.loungeId });
              localStorage.setItem(
                "selectedLocal",
                JSON.stringify({ id: l.loungeId, nombre: l.loungeName })
              );
            }}
            style={{
              position: "relative",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: 10,
              width: 160,
              height: 130,
              border: loginForm.loungeId === l.loungeId ? "2px solid #45348e" : "1px solid #e5e7eb",
              borderRadius: 16,
              background: loginForm.loungeId === l.loungeId ? "#f5f3ff" : "white",
              cursor: "pointer",
              transition: "all 0.15s",
              boxShadow: loginForm.loungeId === l.loungeId ? "0 4px 12px rgba(69,52,142,0.15)" : "none",
            }}
          >
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke={loginForm.loungeId === l.loungeId ? "#45348e" : "#9d8ae6"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 21h18M5 21V7l8-4v18M13 21V3l6 4v14M9 7v.01M9 11v.01M9 15v.01M9 19v.01" />
            </svg>
            <span style={{
              fontSize: 13,
              fontWeight: 600,
              color: loginForm.loungeId === l.loungeId ? "#45348e" : "#1f2937",
              textAlign: "center",
              lineHeight: 1.2,
              maxWidth: 140,
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}>
              {l.loungeName}
            </span>
            {l.isCentral && (
              <span style={{ position: "absolute", top: 6, right: 6, fontSize: 9, fontWeight: 700, color: "#fff", background: "#16a34a", borderRadius: 10, padding: "2px 8px" }}>
                Central
              </span>
            )}
          </button>
        ))}
      </div>
    </article>
  );
};

export default LoungesSelectView;
